import React from "react";
import { useTranslation } from "react-i18next";

function LowCostIcon() {
  const { t } = useTranslation();

  return (
    <span className="lowcost-icon" title={t("OAG_LOWCOST_DISCLAIMER_HEADER")}>
      &#9679;
    </span>
  );
}

export default LowCostIcon;
